import { Section, TextField, Choices } from "./Fields";
import { TAILLES, TERRITOIRES, ETATS, PRIORITES } from "../../content";

export const StepOne = ({ data, set, errors }) => (
  <>
    <Section num="1" title="Vous et votre organisation" testid="fiche-section-1">
      <TextField name="nom" label="Prénom et nom" value={data.nom} onChange={set} required error={errors.nom} autoComplete="name" />
      <TextField name="fonction" label="Fonction" value={data.fonction} onChange={set} required error={errors.fonction} autoComplete="organization-title" />
      <TextField name="organisation" label="Organisation" value={data.organisation} onChange={set} required error={errors.organisation} autoComplete="organization" />
      <TextField name="secteur" label="Secteur d'activité" value={data.secteur} onChange={set} />
      <TextField name="courriel" label="Courriel" type="email" value={data.courriel} onChange={set} required error={errors.courriel} autoComplete="email" />
      <TextField name="telephone" label="Téléphone" type="tel" value={data.telephone} onChange={set} autoComplete="tel" />
      <Choices name="taille" question="Taille de l'organisation" options={TAILLES} value={data.taille} onChange={set} />
      <Choices name="territoire" question="Territoire" options={TERRITOIRES} value={data.territoire} onChange={set} />
    </Section>
    <Section num="2" title="Votre démarche de prévention du mieux-être" testid="fiche-section-2">
      <Choices name="etat_demarche" question="Où en êtes-vous aujourd'hui ?" options={ETATS} value={data.etat_demarche} onChange={set} />
    </Section>
    <Section num="3" title="Vos priorités du moment" testid="fiche-section-3">
      <Choices name="priorites" options={PRIORITES} value={data.priorites} onChange={set} multiple />
      {data.priorites.includes("Autre") && (
        <div className="ob-reveal">
          <TextField name="priorite_autre" label="Précisez votre priorité" value={data.priorite_autre} onChange={set} />
        </div>
      )}
    </Section>
  </>
);
